// extracted by mini-css-extract-plugin
export default {"title_wrap":"data_table_title_wrap__UqPtl","cnt_span":"data_table_cnt_span__c8c2-"};